"use strict";

import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import React, { PureComponent } from 'react';
import Box, { Item } from 'devextreme-react/box';
import { withStyles } from '@material-ui/core/styles';
import { System } from "Constants/objects";
import { D5FormLayoutFilters, D5FormLayoutSubforms, D5FormLayoutDecoration } from "Components/Forms/LayoutItems";
import { D5FormLayoutPanel, D5FormLayoutTabs } from "Components/Forms/LayoutGroups";

var styles = function styles(theme) {
  return {
    d5FormCaption: {
      fontSize: 20,
      borderBottom: '1px solid #d5d9da',
      paddingBottom: 3,
      margin: '0 2px',
      flex: '0 0 auto'
    },
    d5FormContainer: {
      flex: '1 0 auto'
    },
    withCaption: {
      height: 'calc(100% - 41px)'
    },
    fullHeight: {
      height: '100%'
    },
    formStyle: {
      padding: '8px 8px 8px 16px',
      height: '100%'
    }
  };
};

var D5LayoutClass =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(D5LayoutClass, _PureComponent);

  function D5LayoutClass() {
    _classCallCheck(this, D5LayoutClass);

    return _possibleConstructorReturn(this, _getPrototypeOf(D5LayoutClass).apply(this, arguments));
  }

  _createClass(D5LayoutClass, [{
    key: "buildTree",
    value: function buildTree(elements) {
      elements = elements.length ? elements : []; //группируем колонки по parentID

      var grouped = _.groupBy(elements, function (item) {
        return item['parentID'];
      }); //копируем так же поля которые сейчас находяться в группах в обьект groups под соответсвующий ключ
      //каждое поля вставляем в отдельную группу для выравнивания и сортируем их


      _.each(elements, function (item) {
        if (grouped[item['id']]) {
          grouped[item['id']] = _.sortBy(grouped[item['id']], 'order');
        }
      }); //создаем массив групп из исходных данных и записываем сгруппированные группы в группы


      _.each(elements, function (group) {
        if (grouped[group.id] != null) group.items = grouped[group.id] && _toConsumableArray(grouped[group.id]) || [];
      }); //группируем колонки по ParentGroupID


      elements = _.groupBy(elements, function (item) {
        return item['parentID'];
      });
      elements = _toConsumableArray(elements['null']); //записываем все группы у которых нет родителя

      return elements;
    }
  }, {
    key: "containerFactory",
    value: function containerFactory(groupType) {
      var Container = null;

      switch (groupType) {
        case System.GROUP_TYPE.TAB_PANEL:
          Container = D5FormLayoutTabs;
          break;

        default:
          Container = D5FormLayoutPanel;
      }

      return Container;
    }
  }, {
    key: "elementFactory",
    value: function elementFactory(itemType) {
      var Element = null;
      var _System$LAYOUT_TYPE = System.LAYOUT_TYPE,
          FILTER = _System$LAYOUT_TYPE.FILTER,
          SUBFORM = _System$LAYOUT_TYPE.SUBFORM,
          DECORATION = _System$LAYOUT_TYPE.DECORATION;

      switch (itemType) {
        case FILTER:
          Element = D5FormLayoutFilters;
          break;

        case SUBFORM:
          Element = D5FormLayoutSubforms;
          break;

        case DECORATION:
          Element = D5FormLayoutDecoration;
          break;
      }

      return Element;
    }
  }, {
    key: "renderGroup",
    value: function renderGroup(options) {
      var _this = this;

      var id = options.id,
          caption = options.caption,
          groupType = options.groupType,
          items = options.items,
          orientation = options.orientation,
          parentID = options.parentID,
          isGroup = options.isGroup;

      var renderedChildren = _.map(items, function (item) {
        return _this.drawGroupItem(item);
      });

      var Container = this.containerFactory(groupType);
      return React.createElement(Container, {
        caption: caption,
        items: items,
        groupType: groupType,
        id: id,
        orientation: orientation,
        isGroup: isGroup,
        key: "D5FormLayoutContainer-".concat(id)
      }, renderedChildren);
    }
  }, {
    key: "drawGroupItem",
    value: function drawGroupItem(item) {
      if (item.hasOwnProperty('editorType')) return;

      if (item.hasOwnProperty('isGroup') && item.isGroup === true) {
        return this.renderGroup(item);
      }

      return this.renderItem(item);
    }
  }, {
    key: "renderItem",
    value: function renderItem(itemInfo) {
      var itemType = itemInfo.itemType,
          id = itemInfo.id,
          label = itemInfo.label,
          isVisible = itemInfo.isVisible,
          isRequired = itemInfo.isRequired;
      var Element = this.elementFactory(itemType);
      return React.createElement(Element, {
        key: "".concat(itemType, "-").concat(id),
        options: itemInfo.options,
        itemType: itemType,
        id: id,
        label: label,
        isVisible: isVisible,
        isRequired: isRequired
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          classes = _this$props.classes,
          groups = _this$props.groups,
          items = _this$props.items;
      var groupsItemsTree = this.buildTree([].concat(_toConsumableArray(groups), _toConsumableArray(items)));
      var renderedTree = groupsItemsTree.map(function (element) {
        return _this2.drawGroupItem(element);
      });
      return React.createElement(Box, {
        id: "InlineForm",
        className: classes.formStyle,
        direction: "col",
        width: "100%",
        height: "100%"
      }, React.createElement(Item, {
        ratio: 1
      }, renderedTree));
    }
  }]);

  return D5LayoutClass;
}(PureComponent);

export var D5Layout = withStyles(styles)(D5LayoutClass);